import React, { useContext } from 'react';
import { AppContext } from '@thd-nucleus/app-render';
import {
  Route, Routes, ScrollToTop
} from '@thd-olt-component-react/router';
import { ContentfulLivePreviewProvider } from '@contentful/live-preview/react';
import { Error } from './pages';
import { getRoutes } from './routes';
// fetch from utilities
import './styles/app.scss';

export const App = () => {
  const { instance } = useContext(AppContext);

  const {
    currentRouteName,
    currentRouteComponent
  } = instance.router;

  const routes = getRoutes(currentRouteName, currentRouteComponent);

  return (
    <ContentfulLivePreviewProvider locale="en-US" targetOrigin="https://app.contentful.com">
      <ScrollToTop />
      <Routes>
        <Route exact path={routes.landingA.path} element={<routes.landingA.component />} />
        <Route exact path={routes.landingB.path} element={<routes.landingB.component />} />
        <Route exact path={routes.landingC.path} element={<routes.landingC.component />} />
        <Route exact path={routes.landingTest.path} element={<routes.landingTest.component />} />
        {/* <Route exact path={routes.home.path} element={<routes.home.component />} /> */}
        <Route path="/error" element={<Error />} />
        <Route element={<Error />} />
      </Routes>
    </ContentfulLivePreviewProvider>
  );
};

App.propTypes = {};

App.defaultProps = {};